export const BulkRatiosOptions = {
  SpecificAgencies: "Specific Agencies",
  SpecificParentAgency: "Under Specific Agency",
  SpecificAgencyList: "Specific Agency List",
  AgenciesWhoHasSpecificRatios: "Agencies with specific ratio",
  AgenciesWithRatioLargerThan: "Agencies with Ratio Larger than",
  AgenciesWithRatioSmallerThan: "Agencies with Ratio Smaller than",
};
export const BulkRatiosOptionsArray = [
  BulkRatiosOptions.SpecificAgencies,
  BulkRatiosOptions.SpecificParentAgency,
  BulkRatiosOptions.SpecificAgencyList,
  BulkRatiosOptions.AgenciesWhoHasSpecificRatios,
  BulkRatiosOptions.AgenciesWithRatioLargerThan,
  BulkRatiosOptions.AgenciesWithRatioSmallerThan,
];
